//Custo css import
import { BarChart2Icon, DollarSignIcon, ShoppingCartIcon } from 'lucide-react'
import { getInsights } from '../../../usecases/insights-usecase.ts';
import { authContext } from '../../../context/auth/context';
import { roleContext } from '../../../context/role/context';
import { useContext, useEffect, useState } from 'react';
import { useAccountantHub } from '../../../usecases/useAccountantHub';
import { useNavigationIntent } from '../../../hooks/useNavigationIntent';
import { useOnboardingTour } from '../../../hooks/useOnboardingTour';
import './style.css'

import { formatMoney } from '../../../utils/formating.js';

import InsightNumber from '../../atoms/insightNumber/view';
import InsightGroup from '../../organisms/insightGroup/view';
import HubButtonsGroup from '../../organisms/HubButtonsGroup/view';
import ElectronicDocumentConsumption from '../../organisms/ElectronicDocumentConsumption/view';
import InsightTab from '../../atoms/insightTab/view';
import InsightTabGroup from '../../molecules/insightTab/view';
import PaymentModal from '../../organisms/PaymentModal/view';


function AppHub() {

    useOnboardingTour();

    const { logOut } = useContext(authContext);
    const { profile, suscripcion } = useContext(roleContext);
    const { handleAlertClick } = useAccountantHub();
    const intent = useNavigationIntent();
    const [insights, setInsights] = useState(null);
    const [showPayment, setShowPayment] = useState(false);

    useEffect(() => {
        if (suscripcion && suscripcion.status === 'pending') {
            setShowPayment(true);
        }
    }, [suscripcion]);

    useEffect(() => {
        if (intent && intent.action === 'healGaps') {
            handleHealGaps(intent.companyId);
        }
    }, [intent]);

    const handleHealGaps = async (companyId) => {
        const { accountantService } = await import('../../../services/accountantService');
        const Swal = (await import('sweetalert2')).default;

        Swal.fire({
            title: 'Sincronizando Facturas...',
            text: 'Estamos validando los huecos con Plemsi uno por uno.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const res = await accountantService.healGaps(companyId);
            if (res.success) {
                Swal.fire({
                    title: 'Sincronización Completada',
                    text: res.message || `Se recuperaron ${res.data.recovered_count} facturas exitosamente.`,
                    icon: 'success',
                });
            } else {
                Swal.fire('Error', res.data?.message || 'No se pudo completar la sincronización', 'error');
            }
        } catch (e) {
            Swal.fire('Error', 'Ocurrió un error inesperado durante la sincronización', 'error');
        }
    };

    useEffect(() => {
        updateInsights({ detail: { data: { tabIndex: 0 } } });
        window.addEventListener('insights-tab-hub-click', updateInsights);
        return () => {
            window.removeEventListener('insights-tab-hub-click', updateInsights);
        }
    }, [])

    function updateInsights(event) {
        if (!profile) return;
        var index = ['day', 'week', 'month'];
        getInsights(profile.uid, profile.cid, 'hub', index[event.detail.data.tabIndex]).then((res) => {
            setInsights(res.data.metrics);
        })
    }

    function replace(url) {
        window.location.replace(url)
    }

    return (
        <div className="app-hub">
            <PaymentModal isOpen={showPayment} onClose={() => setShowPayment(false)} />
            <header className="hub-header">
                <div className="header-title-section">
                    <h1 className="hub-title">Panel de Control</h1>
                    <p className="hub-subtitle">Resumen general de tu actividad empresarial</p>
                </div>
                <InsightTabGroup id='hub'>
                    <InsightTab>Día</InsightTab>
                    <InsightTab>Semana</InsightTab>
                    <InsightTab>Mes</InsightTab>
                </InsightTabGroup>
            </header>
            <div className="hub-content">
                <ElectronicDocumentConsumption />
                <InsightGroup id='hub-insights' showTabs={false}>
                    <InsightNumber
                        data={insights ? insights["sell_count"] : "---"}
                        lable="Ventas totales"
                        icon={<ShoppingCartIcon />}
                        trend={insights ? insights["sell_count_trend"] : null}
                        trendValue={insights ? insights["sell_count_trend_value"] : ""}
                    />
                    <InsightNumber
                        data={insights ? formatMoney(insights["total_value"]) : "$ ---"}
                        lable="Valor facturado"
                        icon={<DollarSignIcon />}
                        trend={insights ? insights["total_value_trend"] : null}
                        trendValue={insights ? insights["total_value_trend_value"] : ""}
                    />
                    <InsightNumber
                        data={insights ? formatMoney(insights["average_ticket"]) : "$ ---"}
                        lable="Ticket promedio"
                        icon={<BarChart2Icon />}
                        trend={insights ? insights["average_ticket_trend"] : null}
                        trendValue={insights ? insights["average_ticket_trend_value"] : ""}
                    />
                </InsightGroup>
            </div>
        </div>
    )
}

export default AppHub
